import React from 'react';
import { RowView, Text } from '../../helpers';
import { colors } from '../../assets/colors';

type PaymentProviderProps = {
    logoSrc?: string;
    logoAlt?: string;
    style?: React.CSSProperties;
    renderLogo?: () => React.ReactNode;
};

const PaymentProvider = ({ logoSrc, logoAlt = 'Payment provider', style, renderLogo }: PaymentProviderProps) => {
    return (
        <RowView style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
            <Text i="Betallösningen hanteras av " color={colors.dark} />
            {renderLogo ? (
                renderLogo()
            ) : (
                <img alt={`${logoAlt} logo`} style={{ ...style }} src={logoSrc} />
            )}
        </RowView>
    );
};

export default PaymentProvider;
